import styled from 'styled-components';

import { StyledTextField as BaseTextField } from 'components/Input/styles';

export const StyledTextField = styled(BaseTextField)<{
  hasError?: boolean;
}>`
  input {
    width: 65px;
    height: 65px;
    font-size: 20px;
    ${({ hasError, theme }) => hasError && `border: 2px solid ${theme.palette.error.main}; border-radius: 4px;`}
  }

  & input[type='number'] {
    -moz-appearance: textfield;
  }

  & input[type='number']::-webkit-outer-spin-button,
  & input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;
